export default "__VITE_ASSET__CHWPmAEo__"